<template>
  <div id="news">
    <bread :content="breadContent"></bread>
    <p class="Page-title">中心资讯</p>
    <el-divider></el-divider>
    <div id="flex">
      <div id="content">
        <blockTime :year="time.year" :month="time.month" :day="time.day"></blockTime>
        <div class="body-left">
          <Article :margin="'20px 0 0 0'" :title="detailData.Title" :subTitle="detailData.SubTitle" :authors="detailData.Author" :html="detailData.Content"></Article>
          <about-link :Links="detailData.Links"></about-link>
        </div>
      </div>
      <div id="right">
        <timeline :list="timelineData.list" :iconSrc="timelineData.iconSrc" :title="'最新资讯'" :titleColor="'red'"></timeline>
      </div>
    </div>
  </div>
</template>
<script>
import bread from "@/components/bread";
import timeline from "@/components/timeline";
import Api from "@/network.js";
import Article from "@/components/article";
import blockTime from "@/components/blockTime";
import aboutLink from "@/components/link";
import utils from "@/utils.js";
export default {
  components: {
    bread,
    timeline,
    blockTime,
    aboutLink,
    Article
  },
  name: "news",
  async beforeRouteEnter(to, from, next) {
    let res = await Api.getArticle(to.query.id);
    let timeRes = await Api.index.getLast("zxzx");
    let time = utils.timeResult(res.AdminSetTime);
    next(vm => {
      vm.detailData = res;
      vm.time = time;
      for (let item of timeRes) {
        vm.timelineData.list.push({
          date: item.Date,
          content: item.Title,
          url: `/index/news?id=${encodeURIComponent(item.Id)}`
        });
      }
    });
  },
  watch: {
    $route() {
      this.$router.go(0);
    }
  },
  data() {
    return {
      timelineData: {
        title: "最新热点",
        iconSrc: require("../../assets/fire-icon.png"),
        list: []
      },
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "中心资讯", routerName: "" }
      ],
      content: "",
      time: {},
      detailData: {
        Links: []
      }
    };
  }
};
</script>
  
<style lang="scss" scoped>
#news {
  width: 75%;
  margin-left: 15%;
  margin-top: 80px;
  margin-bottom: 200px;
  #content {
    width: 70%;
    margin-left: 5%;
    display: flex;
    position: relative;
    flex-direction: column;
    .blockTime {
      position: absolute;
      left: 0;
      top: -10px;
    }
    #title {
      text-align: center;
      padding: 0 75px;
      font-size: 24px;
      margin-top: 15px;
      margin-bottom: 30px;
    }
    #detail {
      font-size: 18px;
      margin-bottom: 40px;
    }
  }
  #flex {
    display: flex;
    justify-content: space-around;
  }
  .link {
    margin-top: 80px;
  }
}
</style>

